module.exports = __webpack_public_path__ + "img/companyApply.f2eccdb4.jpg";